export enum SidebarIcons {
  Phone = 'Phone',
  CircleCheck = 'CircleCheck',
}
